import { Col, Row } from '@microfrontends/react-components'
import styled, { css } from 'styled-components'

export const Title = styled.p`
	font-weight: 700;
	font-size: 20px;
	line-height: 30px;
	/* @media (max-width: 767px) {
		font-weight: 700;
		font-size: 20px;
		line-height: 30px;
	} */
`

export const ViewAllButton = styled(Col)<{ isBottom?: boolean }>`
	text-align: right;
	a {
		color: #005aff;
		text-decoration: none;
	}
	&:hover {
		a {
			color: #ff7d55;
		}
		svg {
			path {
				fill: #ff7d55;
			}
		}
	}
	${({ isBottom }) => {
		if (!isBottom) {
			return ''
		}
		return css`
			a {
				display: block;
				width: 100%;
				background-color: #f2f7ff;
				border-radius: 6px;
				text-align: center;
				padding: 12px 0;
				margin-top: 8px;
			}
		`
	}}
`

export const WowCvWrap = styled(Row)`
	background: #fff;
	border-radius: 12px;
	@media (max-width: 767px) {
	}
`

export const MostUsageCVWrapper = styled.div`
	${ViewAllButton} {
		background-color: #f2f7ff;
		border-radius: 6px;
		width: calc(100% - 16px);
		padding: 12px 0;
		text-align: center;
	}
`

export const MostUsageTitle = styled(Title)`
	width: 50%;
	@media (max-width: 767px) {
		width: 100%;
	}
`

export const ButtonWrapper = styled.div`
	display: none;
`

export const CVPreview = styled.a`
	display: inline-block;
	width: 100%;
	border: 1px solid #e2e2e2;
	border-radius: 6px;
	margin-right: 16px;
	aspect-ratio: 0.7073;
	object-fit: cover;
	position: relative;
	img {
		border-radius: 6px;
	}
	@media screen and (max-width: 768px) {
		width: calc(100% - 16px);
	}
	&:hover {
		&::before {
			content: ' ';
			background-color: rgba(0, 0, 0, 0.7);
			border-radius: 6px;
			display: block;
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			z-index: 1;
		}
		${ButtonWrapper} {
			position: absolute;
			z-index: 2;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: 6px;
		}
	}
`
